/* Fumer rail - inline continuously-rotating carousel. Drives any [data-fs-rail].
   SPEED IS TUNED HERE, in one place, for every rail on the site.
   Higher number = faster drift (pixels per animation frame).
   The data-speed attribute on a section is ignored on purpose - keeping all
   three rails in one table stops them drifting out of sync with each other. */
(function () {
  var SPEEDS = {
    'fs-rail--catg':  0.55,   /* Shop By Category */
    'fs-rail--goals': 0.55,   /* What are you building? */
    'fs-rail--alm':   0.50    /* The Fumer Almanac */
  };
  var DEFAULT_SPEED = 0.55;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function gapOf(el) {
    var cs = window.getComputedStyle(el);
    return parseFloat(cs.columnGap || cs.gap || '0') || 0;
  }

  function speedFor(rail) {
    for (var k in SPEEDS) {
      if (Object.prototype.hasOwnProperty.call(SPEEDS, k) && rail.classList.contains(k)) return SPEEDS[k];
    }
    return DEFAULT_SPEED;
  }

  function init(rail) {
    if (rail.getAttribute('data-fs-rail-ready') === '1') return;
    rail.setAttribute('data-fs-rail-ready', '1');

    var track = rail.querySelector('[data-fs-rail-track]');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    var speed = speedFor(rail);
    var gap = gapOf(track);
    var loopW = track.scrollWidth + gap;

    var need = Math.max(2, Math.ceil(((rail.offsetWidth || 1200) * 2) / Math.max(loopW, 1)) + 1);
    for (var r = 1; r < need; r++) {
      for (var i = 0; i < originals.length; i++) {
        var c = originals[i].cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        var focusables = c.querySelectorAll('a,button,input,select,textarea');
        for (var f = 0; f < focusables.length; f++) focusables[f].setAttribute('tabindex', '-1');
        track.appendChild(c);
      }
    }

    var x = 0, paused = false, dragging = false, moved = false, startX = 0, startPos = 0;

    function remeasure() {
      gap = gapOf(track);
      var one = 0;
      for (var i = 0; i < originals.length; i++) one += originals[i].getBoundingClientRect().width + gap;
      if (one > 0) loopW = one;
    }
    remeasure();
    window.addEventListener('resize', remeasure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);

    function wrap() {
      if (loopW <= 0) return;
      while (-x >= loopW) x += loopW;
      while (x > 0) x -= loopW;
    }
    function paint() { track.style.transform = 'translate3d(' + x + 'px,0,0)'; }

    function frame() {
      if (!paused && !dragging) { x -= speed; wrap(); paint(); }
      window.requestAnimationFrame(frame);
    }
    if (!reduce) window.requestAnimationFrame(frame);

    rail.addEventListener('mouseenter', function () { paused = true; });
    rail.addEventListener('mouseleave', function () { paused = false; });
    rail.addEventListener('focusin', function () { paused = true; });
    rail.addEventListener('focusout', function () { paused = false; });

    rail.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true; moved = false; startX = e.clientX; startPos = x;
      rail.classList.add('is-drag');
      try { rail.setPointerCapture(e.pointerId); } catch (err) {}
    });
    rail.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      x = startPos + dx; wrap(); paint();
    });
    function endDrag() { if (!dragging) return; dragging = false; rail.classList.remove('is-drag'); }
    rail.addEventListener('pointerup', endDrag);
    rail.addEventListener('pointercancel', endDrag);
    rail.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    function nudge(dir) {
      var w = originals[0].getBoundingClientRect().width + gap;
      x += dir * w; wrap();
      track.style.transition = 'transform .55s cubic-bezier(.16,1,.3,1)';
      paint();
      window.setTimeout(function () { track.style.transition = ''; }, 580);
    }
    var scope = rail.closest('section') || rail.parentNode;
    var prev = scope.querySelectorAll('[data-fs-rail-prev]');
    var next = scope.querySelectorAll('[data-fs-rail-next]');
    for (var p = 0; p < prev.length; p++) prev[p].addEventListener('click', function () { nudge(1); });
    for (var n = 0; n < next.length; n++) next[n].addEventListener('click', function () { nudge(-1); });
  }

  function boot() {
    var rails = document.querySelectorAll('[data-fs-rail]');
    for (var i = 0; i < rails.length; i++) init(rails[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();